export default function () {
    return {
        template: require('./tag-container.html'),
        controller,
        controllerAs: 'tagView'
    };

    function controller(tagSwitchService) {
        const vm = this;

        vm.showCreate = false;

        tagSwitchService.subscribe('load-create', () => {
            vm.showCreate = true;
        });

        tagSwitchService.subscribe('load-list', () => {
            vm.showCreate = false;
        });

        setTimeout(() => tagSwitchService.publish('load-list'), 10);
    }
}



// WEBPACK FOOTER //
// ./Client/app/tasks/tags/tagDirective.js